var _style, _style2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextloding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: 277,
    height: 34,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  text {\n    text-anchor: middle; font-size: 38px; opacity: 0;\n  }\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "138.5px 17px",
      transform: "scale(0.475)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.5,17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-244.135px -4.60578px",
      animation: "2.7027s linear -1.6723s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.92-46.88L3.13-46.88L3.13-44.84L9.38-44.84L9.38-2.03L3.13-2.03L3.13 0L24.69 0L24.69 0Q35.23 0 42.03-6.56L42.03-6.56L42.03-6.56Q48.75-13.05 48.75-23.44L48.75-23.44L48.75-23.44Q48.75-36.88 38.91-43.13L38.91-43.13L38.91-43.13Q32.89-46.88 24.92-46.88L24.92-46.88zM16.09-44.84L24.69-44.84L24.69-44.84Q37.03-44.84 40.08-33.59L40.08-33.59L40.08-33.59Q41.25-29.45 41.25-23.75L41.25-23.75L41.25-23.75Q41.25-4.30 27.97-2.27L27.97-2.27L27.97-2.27Q26.48-2.03 24.92-2.03L24.92-2.03L16.09-2.03L16.09-44.84",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-197.03px 2.23422px",
      animation: "2.7027s linear -1.56081s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.59 0.78L83.59 0.78L83.59 0.78Q89.61 0.78 90.23-6.48L90.23-6.48L90.23-6.48Q90.31-6.95 90.31-7.34L90.31-7.34L88.28-7.42L88.28-7.42Q87.73-1.72 85.23-1.64L85.23-1.64L85.23-1.64Q83.20-1.80 83.13-5.70L83.13-5.70L83.13-22.19L83.13-22.19Q83.13-33.36 71.95-33.98L71.95-33.98L71.95-33.98Q71.25-33.98 70.55-33.98L70.55-33.98L70.55-33.98Q61.80-33.98 58.83-29.92L58.83-29.92L58.83-29.92Q57.89-28.59 57.89-27.27L57.89-27.27L57.89-27.27Q57.89-24.84 60.16-24.45L60.16-24.45L60.16-24.45Q60.55-24.38 60.94-24.38L60.94-24.38L60.94-24.38Q62.73-24.38 63.59-26.64L63.59-26.64L63.59-26.64Q64.69-29.53 65.08-30.08L65.08-30.08L65.08-30.08Q66.56-32.03 69.69-32.03L69.69-32.03L69.69-32.03Q77.03-31.56 77.27-23.98L77.27-23.98L77.27-19.06L77.27-19.06Q58.91-19.06 56.25-11.41L56.25-11.41L56.25-11.41Q55.78-9.92 55.78-8.20L55.78-8.20L55.78-8.20Q55.78-2.27 61.02-0.08L61.02-0.08L61.02-0.08Q63.13 0.78 65.47 0.78L65.47 0.78L65.47 0.78Q71.17 0.78 75.08-3.13L75.08-3.13L75.08-3.13Q76.48-4.61 77.19-6.25L77.19-6.25L77.19-6.25Q78.13 0.70 83.59 0.78zM68.05-2.34L68.05-2.34L68.05-2.34Q63.28-2.34 62.19-7.11L62.19-7.11L62.19-7.11Q61.95-8.20 61.95-9.53L61.95-9.53L61.95-9.53Q61.95-14.77 67.97-16.17L67.97-16.17L67.97-16.17Q71.17-16.88 77.27-16.95L77.27-16.95L77.27-10.70L77.27-10.70Q76.09-5.31 71.56-3.13L71.56-3.13L71.56-3.13Q69.77-2.34 68.05-2.34",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-166.09px -1.87078px",
      animation: "2.7027s linear -1.44932s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.27-33.20L92.27-31.25L97.73-31.25L97.73-9.22L97.73-9.22Q98.28 0.55 106.72 0.86L106.72 0.86L106.72 0.86Q113.91 0.86 115.70-7.97L115.70-7.97L115.70-7.97Q115.70-8.05 115.70-8.13L115.70-8.13L113.59-8.52L113.59-8.52Q111.64-2.03 107.89-1.48L107.89-1.48L107.89-1.48Q103.67-1.64 103.59-7.50L103.59-7.50L103.59-31.25L115.70-31.25L115.70-33.20L103.59-33.20L103.59-42.27L97.73-40.63L97.73-33.20L92.27-33.20",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-133.98px 2.23422px",
      animation: "2.7027s linear -1.33784s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.64 0.78L146.64 0.78L146.64 0.78Q152.66 0.78 153.28-6.48L153.28-6.48L153.28-6.48Q153.36-6.95 153.36-7.34L153.36-7.34L151.33-7.42L151.33-7.42Q150.78-1.72 148.28-1.64L148.28-1.64L148.28-1.64Q146.25-1.80 146.17-5.70L146.17-5.70L146.17-22.19L146.17-22.19Q146.17-33.36 135-33.98L135-33.98L135-33.98Q134.30-33.98 133.59-33.98L133.59-33.98L133.59-33.98Q124.84-33.98 121.88-29.92L121.88-29.92L121.88-29.92Q120.94-28.59 120.94-27.27L120.94-27.27L120.94-27.27Q120.94-24.84 123.20-24.45L123.20-24.45L123.20-24.45Q123.59-24.38 123.98-24.38L123.98-24.38L123.98-24.38Q125.78-24.38 126.64-26.64L126.64-26.64L126.64-26.64Q127.73-29.53 128.13-30.08L128.13-30.08L128.13-30.08Q129.61-32.03 132.73-32.03L132.73-32.03L132.73-32.03Q140.08-31.56 140.31-23.98L140.31-23.98L140.31-19.06L140.31-19.06Q121.95-19.06 119.30-11.41L119.30-11.41L119.30-11.41Q118.83-9.92 118.83-8.20L118.83-8.20L118.83-8.20Q118.83-2.27 124.06-0.08L124.06-0.08L124.06-0.08Q126.17 0.78 128.52 0.78L128.52 0.78L128.52 0.78Q134.22 0.78 138.13-3.13L138.13-3.13L138.13-3.13Q139.53-4.61 140.23-6.25L140.23-6.25L140.23-6.25Q141.17 0.70 146.64 0.78zM131.09-2.34L131.09-2.34L131.09-2.34Q126.33-2.34 125.23-7.11L125.23-7.11L125.23-7.11Q125-8.20 125-9.53L125-9.53L125-9.53Q125-14.77 131.02-16.17L131.02-16.17L131.02-16.17Q134.22-16.88 140.31-16.95L140.31-16.95L140.31-10.70L140.31-10.70Q139.14-5.31 134.61-3.13L134.61-3.13L134.61-3.13Q132.81-2.34 131.09-2.34",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-79.76px -4.60578px",
      animation: "2.7027s linear -1.22635s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.11 0L194.45 0L194.45-2.03L185.08-2.03L185.08-23.05L201.17-23.05L201.17-25.31L185.08-25.31L185.08-44.84L197.58-44.84L197.58-44.84Q203.20-44.84 205.63-37.27L205.63-37.27L205.63-37.27Q205.78-36.80 205.86-36.48L205.86-36.48L206.95-32.81L208.52-32.81L208.13-46.88L172.11-46.88L172.11-44.84L178.36-44.84L178.36-2.03L172.11-2.03L172.11 0",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-42.46px 2.23422px",
      animation: "2.7027s linear -1.11486s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.75-32.03L228.75-32.03L228.75-32.03Q234.22-32.03 236.02-27.42L236.02-27.42L236.02-27.42Q236.64-25.94 236.64-24.22L236.64-24.22L236.64-24.22Q236.64-20.31 232.89-19.45L232.89-19.45L232.89-19.45Q230.94-19.06 227.34-19.14L227.34-19.14L219.06-19.38L219.06-19.38Q219.45-28.36 224.92-31.09L224.92-31.09L224.92-31.09Q226.72-32.03 228.75-32.03zM242.34-7.50L242.34-7.50L240.39-8.20L240.39-8.20Q237.66-2.27 231.56-1.48L231.56-1.48L231.56-1.48Q230.78-1.41 230.08-1.41L230.08-1.41L230.08-1.41Q221.88-1.41 219.77-11.17L219.77-11.17L219.77-11.17Q219.14-13.91 219.06-17.19L219.06-17.19L228.44-17.03L228.44-17.03Q237.97-16.88 240.70-18.83L240.70-18.83L240.70-18.83Q242.81-20.39 242.81-23.28L242.81-23.28L242.81-23.28Q242.81-28.59 237.42-31.72L237.42-31.72L237.42-31.72Q233.59-33.98 228.59-33.98L228.59-33.98L228.59-33.98Q218.83-33.98 214.61-25.86L214.61-25.86L214.61-25.86Q212.42-21.64 212.42-16.33L212.42-16.33L212.42-16.33Q212.42-6.64 219.38-1.95L219.38-1.95L219.38-1.95Q223.52 0.78 228.83 0.78L228.83 0.78L228.83 0.78Q237.27 0.78 241.25-5.31L241.25-5.31L241.25-5.31Q241.88-6.41 242.34-7.50",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-11.245px -1.87078px",
      animation: "2.7027s linear -1.00338s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.11-33.20L247.11-31.25L252.58-31.25L252.58-9.22L252.58-9.22Q253.13 0.55 261.56 0.86L261.56 0.86L261.56 0.86Q268.75 0.86 270.55-7.97L270.55-7.97L270.55-7.97Q270.55-8.05 270.55-8.13L270.55-8.13L268.44-8.52L268.44-8.52Q266.48-2.03 262.73-1.48L262.73-1.48L262.73-1.48Q258.52-1.64 258.44-7.50L258.44-7.50L258.44-31.25L270.55-31.25L270.55-33.20L258.44-33.20L258.44-42.27L252.58-40.63L252.58-33.20L247.11-33.20",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "19.22px 2.23422px",
      animation: "2.7027s linear -0.891892s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.06-16.25L274.06-16.25L274.06-16.25Q274.06-6.80 281.02-2.11L281.02-2.11L281.02-2.11Q285.31 0.78 290.78 0.78L290.78 0.78L290.78 0.78Q298.91 0.78 303.05-4.92L303.05-4.92L303.05-4.92Q303.98-6.25 304.53-7.58L304.53-7.58L302.50-8.28L302.50-8.28Q299.61-2.11 292.97-1.48L292.97-1.48L292.97-1.48Q292.34-1.41 291.72-1.41L291.72-1.41L291.72-1.41Q286.17-1.41 283.05-6.95L283.05-6.95L283.05-6.95Q280.70-11.17 280.70-16.95L280.70-16.95L280.70-16.95Q280.70-27.19 286.09-30.63L286.09-30.63L286.09-30.63Q288.36-32.03 291.09-32.03L291.09-32.03L291.09-32.03Q295.31-32.03 296.17-28.75L296.17-28.75L296.17-28.75Q296.33-28.13 296.56-26.80L296.56-26.80L296.56-26.80Q297.03-23.67 298.28-22.89L298.28-22.89L298.28-22.89Q299.06-22.50 300-22.42L300-22.42L300-22.42Q302.66-22.27 303.36-24.61L303.36-24.61L303.36-24.61Q303.52-25.16 303.52-25.63L303.52-25.63L303.52-25.63Q303.52-29.61 298.44-32.19L298.44-32.19L298.44-32.19Q294.84-33.98 290.63-33.98L290.63-33.98L290.63-33.98Q280.16-33.98 276.02-25.47L276.02-25.47L276.02-25.47Q274.06-21.41 274.06-16.25",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "57.385px -6.55577px",
      animation: "2.7027s linear -0.780405s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.05-1.95L323.05-1.95L319.14-1.95L319.14-18.83L319.14-18.83Q319.14-25.94 324.06-29.14L324.06-29.14L324.06-29.14Q326.09-30.47 328.28-30.47L328.28-30.47L328.28-30.47Q333.05-30.47 334.92-26.02L334.92-26.02L334.92-26.02Q335.78-23.91 335.78-21.33L335.78-21.33L335.78-6.64L335.78-6.64Q335.78-3.05 334.06-2.34L334.06-2.34L334.06-2.34Q332.97-1.95 330.31-1.95L330.31-1.95L330.31 0L347.50 0L347.50 0Q347.50-1.72 346.33-1.88L346.33-1.88L346.33-1.88Q346.02-1.95 345.55-1.95L345.55-1.95L341.64-1.95L341.64-21.33L341.64-21.33Q341.64-29.84 336.02-32.89L336.02-32.89L336.02-32.89Q333.83-33.98 331.33-33.98L331.33-33.98L331.33-33.98Q325.55-33.98 321.64-29.77L321.64-29.77L321.64-29.77Q320-27.97 319.14-25.70L319.14-25.70L319.14-50.78L307.42-50.78L307.42-48.83L313.28-48.83L313.28-6.64L313.28-6.64Q313.28-3.05 311.25-2.34L311.25-2.34L311.25-2.34Q310.08-1.95 307.42-1.95L307.42-1.95L307.42 0L325 0L325 0Q325-1.72 323.83-1.88L323.83-1.88L323.83-1.88Q323.52-1.95 323.05-1.95",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "90.785px 2.23422px",
      animation: "2.7027s linear -0.668919s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.89-1.95L367.89-1.95L363.98-1.95L363.98-33.20L351.88-33.20L351.88-31.25L358.13-31.25L358.13-6.64L358.13-6.64Q358.13-3.05 355.70-2.27L355.70-2.27L355.70-2.27Q354.53-1.95 351.88-1.95L351.88-1.95L351.88 0L369.84 0L369.84 0Q369.84-1.72 368.67-1.88L368.67-1.88L368.67-1.88Q368.28-1.95 367.89-1.95",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "90.59px -25.7758px",
      animation: "2.7027s linear -0.557432s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.92-44.61L364.92-44.61L364.92-44.61Q364.92-47.34 362.50-48.52L362.50-48.52L362.50-48.52Q361.56-48.91 360.70-48.91L360.70-48.91L360.70-48.91Q357.97-48.91 356.80-46.41L356.80-46.41L356.80-46.41Q356.41-45.55 356.41-44.61L356.41-44.61L356.41-44.61Q356.41-41.72 358.98-40.63L358.98-40.63L358.98-40.63Q359.84-40.31 360.70-40.31L360.70-40.31L360.70-40.31Q363.44-40.31 364.53-42.81L364.53-42.81L364.53-42.81Q364.92-43.67 364.92-44.61",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "124.495px 1.84422px",
      animation: "2.7027s linear -0.445946s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.77-1.95L389.77-1.95L386.25-1.95L386.25-18.83L386.25-18.83Q386.48-26.09 391.41-29.30L391.41-29.30L391.41-29.30Q393.52-30.63 395.70-30.63L395.70-30.63L395.70-30.63Q400.47-30.63 402.19-26.17L402.19-26.17L402.19-26.17Q402.89-24.38 402.89-22.11L402.89-22.11L402.89-6.64L402.89-6.64Q402.89-3.05 400.86-2.34L400.86-2.34L400.86-2.34Q399.69-1.95 397.03-1.95L397.03-1.95L397.03 0L414.61 0L414.61 0Q414.61-1.72 413.44-1.88L413.44-1.88L413.44-1.88Q413.13-1.95 412.66-1.95L412.66-1.95L408.75-1.95L408.75-21.33L408.75-21.33Q408.75-29.14 403.36-32.50L403.36-32.50L403.36-32.50Q400.86-33.98 397.97-33.98L397.97-33.98L397.97-33.98Q392.19-33.98 388.44-29.38L388.44-29.38L388.44-29.38Q387.03-27.58 386.17-25.39L386.17-25.39L385.86-33.20L374.53-33.20L374.53-31.25L380.39-31.25L380.39-6.64L380.39-6.64Q380.39-3.05 378.36-2.34L378.36-2.34L378.36-2.34Q377.19-1.95 374.53-1.95L374.53-1.95L374.53 0L391.72 0L391.72 0Q391.72-1.72 390.55-1.88L390.55-1.88L390.55-1.88Q390.23-1.95 389.77-1.95",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "166.88px 7.15422px",
      animation: "2.7027s linear -0.334459s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.72-21.64L426.72-21.64L426.72-21.64Q426.88-31.95 434.53-32.03L434.53-32.03L434.53-32.03Q442.19-31.88 442.27-21.64L442.27-21.64L442.27-21.64Q442.11-11.02 434.53-10.94L434.53-10.94L434.53-10.94Q426.80-11.09 426.72-21.64zM434.61-33.98L434.61-33.98L434.61-33.98Q427.58-33.98 423.44-29.45L423.44-29.45L423.44-29.45Q420.47-26.09 420.47-21.56L420.47-21.56L420.47-21.56Q420.47-15.63 426.25-11.72L426.25-11.72L426.25-11.72Q426.80-11.33 427.34-11.02L427.34-11.02L427.34-11.02Q422.34-11.02 421.09-6.72L421.09-6.72L421.09-6.72Q420.86-5.70 420.86-4.69L420.86-4.69L420.86-4.69Q420.94-0.55 424.22 1.48L424.22 1.48L424.22 1.48Q421.64 4.22 421.64 7.03L421.64 7.03L421.64 7.03Q421.64 11.33 426.72 13.44L426.72 13.44L426.72 13.44Q429.92 14.84 434.61 14.84L434.61 14.84L434.61 14.84Q446.48 14.84 450.31 9.06L450.31 9.06L450.31 9.06Q451.56 7.11 451.56 4.92L451.56 4.92L451.56 4.92Q451.56-1.80 443.83-2.81L443.83-2.81L443.83-2.81Q442.81-2.97 441.72-2.97L441.72-2.97L427.50-3.28L427.50-3.28Q423.91-3.52 423.83-6.41L423.83-6.41L423.83-6.41Q423.83-8.44 426.41-8.98L426.41-8.98L426.41-8.98Q426.95-9.06 427.58-9.06L427.58-9.06L434.45-8.98L434.45-8.98Q441.41-8.98 445.55-13.67L445.55-13.67L445.55-13.67Q448.52-17.03 448.52-21.64L448.52-21.64L448.52-21.64Q448.44-27.50 443.98-31.02L443.98-31.02L443.98-31.02Q444.69-33.52 446.64-33.98L446.64-33.98L446.64-33.98Q446.95-34.06 447.27-34.06L447.27-34.06L447.27-34.06Q448.36-34.06 449.61-32.89L449.61-32.89L449.61-32.89Q450.47-32.11 451.17-32.11L451.17-32.11L451.17-32.11Q453.13-32.58 453.44-34.61L453.44-34.61L453.44-34.61Q453.44-37.03 451.17-37.89L451.17-37.89L451.17-37.89Q450.31-38.20 449.45-38.20L449.45-38.20L449.45-38.20Q445.78-38.20 443.52-34.92L443.52-34.92L443.52-34.92Q442.66-33.67 442.19-32.19L442.19-32.19L442.19-32.19Q438.67-33.98 434.61-33.98zM434.61 12.81L434.61 12.81L434.61 12.81Q426.88 12.81 424.84 8.75L424.84 8.75L424.84 8.75Q424.30 7.66 424.30 6.56L424.30 6.56L424.30 6.56Q424.38 4.45 426.17 2.34L426.17 2.34L426.17 2.34Q427.73 2.66 428.75 2.66L428.75 2.66L440.78 2.81L440.78 2.81Q446.64 2.89 447.58 5.47L447.58 5.47L447.58 5.47Q447.81 6.09 447.81 7.03L447.81 7.03L447.81 7.03Q447.81 10.47 441.41 12.03L441.41 12.03L441.41 12.03Q438.28 12.81 434.61 12.81",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "207.19px 15.1992px",
      animation: "2.7027s linear -0.222973s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.25-3.59L481.25-3.59L481.25-3.59Q481.25-6.17 478.91-7.27L478.91-7.27L478.91-7.27Q478.13-7.66 477.27-7.66L477.27-7.66L477.27-7.66Q474.69-7.66 473.67-5.31L473.67-5.31L473.67-5.31Q473.28-4.45 473.28-3.59L473.28-3.59L473.28-3.59Q473.28-1.09 475.55 0L475.55 0L475.55 0Q476.41 0.39 477.27 0.39L477.27 0.39L477.27 0.39Q479.77 0.39 480.86-1.88L480.86-1.88L480.86-1.88Q481.25-2.73 481.25-3.59",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "238.21px 15.1992px",
      animation: "2.7027s linear -0.111486s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.27-3.59L512.27-3.59L512.27-3.59Q512.27-6.17 509.92-7.27L509.92-7.27L509.92-7.27Q509.14-7.66 508.28-7.66L508.28-7.66L508.28-7.66Q505.70-7.66 504.69-5.31L504.69-5.31L504.69-5.31Q504.30-4.45 504.30-3.59L504.30-3.59L504.30-3.59Q504.30-1.09 506.56 0L506.56 0L506.56 0Q507.42 0.39 508.28 0.39L508.28 0.39L508.28 0.39Q510.78 0.39 511.88-1.88L511.88-1.88L511.88-1.88Q512.27-2.73 512.27-3.59",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "269.22px 15.1992px",
      animation: "2.7027s linear 0s infinite normal forwards running fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.28-3.59L543.28-3.59L543.28-3.59Q543.28-6.17 540.94-7.27L540.94-7.27L540.94-7.27Q540.16-7.66 539.30-7.66L539.30-7.66L539.30-7.66Q536.72-7.66 535.70-5.31L535.70-5.31L535.70-5.31Q535.31-4.45 535.31-3.59L535.31-3.59L535.31-3.59Q535.31-1.09 537.58 0L537.58 0L537.58 0Q538.44 0.39 539.30 0.39L539.30 0.39L539.30 0.39Q541.80 0.39 542.89-1.88L542.89-1.88L542.89-1.88Q543.28-2.73 543.28-3.59",
    fill: "#141414",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-270.07501220703125,18.834224739074706)",
    style: {
      fill: "rgb(20, 20, 20)"
    }
  }))))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    id: "fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2",
    "data-anikit": ""
  }, "@keyframes fade-f14cf57f-e245-4cbb-baed-33f5f4aef1a2\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.2057,0.573,0.3723,0.9184);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextloding);
export default __webpack_public_path__ + "static/media/textloding.cb24080b1b186c01d47eee0c0d8f9662.svg";
export { ForwardRef as ReactComponent };